<template>
  <section class="pb-8" id="contact">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row justify="center">
            <v-col cols="12" sm="5">
              <h1 class="font-weight-light display-1">Get in Touch</h1>
              <h3 class="font-weight-light mt-3">
                Tell us how we can help speed your digital transformation.
              </h3>
              <br />

              <h4 class="font-weight-light mt-3">Telephone: +234 (081)-1120-9383</h4>
              <h4 class="font-weight-light">Email: info@softekh.com</h4>

              <br /><br /> <br /> <br />
              <h4 class="font-weight-light">
                Plot 146, Sauka Ext. Layout Behind FCMB Ind. street Kuje, FCT Abuja, Nigeria
              </h4>
            </v-col>
            <v-col cols="12" sm="7">
              <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-text-field
                  v-model="name"
                  :rules="nameRules"
                  label="Name"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>

                <v-textarea
                  v-model="textArea"
                  :rules="textAreaRules"
                  label="Message"
                  required
                />

                <v-btn
                  :disabled="!valid"
                  color="primary"
                  :dark="valid"
                  rounded
                  block
                  class="mt-3"
                  @click="submit">
                  Send
                </v-btn>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-waves text-white">
      <v-img src="~@/assets/img/borderWavesBlue.svg" />
    </div>
    <v-snackbar
      v-model="snackbar.enabled"
      timeout="3000"
      right
      top
      :color="snackbar.color"
    >
      {{ snackbar.text }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.enabled = false"> Close </v-btn>
      </template>
    </v-snackbar>
  </section>
</template>

<style scoped>
#contact {
  background-color: #f4f7f5;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}
</style>

<script>
import emailjs from 'emailjs-com'

export default {
  data: () => ({
    icons: ["fa-facebook", "fa-twitter", "fa-linkedin"],
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "The name field is required",
      (v) => (v && v.length >= 6) || "The name must be longer than 6 characters",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "The email field is mandatory",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    textArea: "",
    textAreaRules: [
      (v) => !!v || "The text field is mandatory",
      (v) => (v && v.length >= 16) || "Minimum of 16 characters",
    ],
    lazy: false,
    snackbar: {
      enabled: false,
      text: "",
      color: "",
    },
  }),
  methods: {
    submit() {
      let data = {
           name: this.name,
           email: this.email,
           message: this.textArea
      };
    
        emailjs.send('service_r4rzw4o', 'template_btogw0v', data,
         'user_CMf55D06eazdKSlVN3UCY').then((response) => {
           console.log('SUCCESS!', response.status, response.text);
        this.snackbar.text = "Message sent successfully"
        this.snackbar.color = "success"
        this.snackbar.enabled = true
        this.name = ''
        this.email = ''
        this.textArea = ''
      }).catch(() => {
        this.snackbar.text = "Error sending message"
        this.snackbar.color = "danger"
        this.snackbar.enabled = true
      })
    },
   },
};
</script>
